module.exports = __webpack_public_path__ + "img/32.e7f33ec5.gif";